import { useTranslation } from 'react-i18next'
import { GetReleaseItemOwners, Release } from '../releases'
import { useAuth } from '../../../hooks/useAuth'
import './ReleaseContainer.scss'
import React from 'react'

export function ReleaseContainer(props: { release: Release }) {
  const { user } = useAuth()
  const { i18n } = useTranslation('common')
  const lang = i18n.language as 'en' | 'de' | 'fr' | 'it'
  return (
    <div className="releaseNotesContent">
      <div>
        <h3>{`Release ${props.release.name} - ${props.release.date}`}</h3>
        {props.release.features?.map((f, i) => (
          <React.Fragment key={i}>
            <div className="center release-feature">
              <strong>
                {f.title[lang]}{' '}
                <div className="iconArea">
                  {user?.isAdmin && GetReleaseItemOwners(f).internal && <i className="icon-ail" />}
                  {user?.isAdmin && GetReleaseItemOwners(f).customer && <i className="icon-users" />}
                  {user?.isAdmin && GetReleaseItemOwners(f).interfleetPro && <i className="icon-4u" />}
                </div>
              </strong>
            </div>
            {f.body}
            <br />
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
